import {http} from '@/core/init';
export default {
    namespaced: true,
    state: {
        invoice: "",
        ok: false
    },
    mutations: {
        SET_OK: (state) => {
            state.ok = true
        },
    },
    actions: {

        add: ({commit}, note) => {
            return new Promise((resolve, reject) => {
                http.post('/facturar', JSON.stringify(note))
                    .then((response) => {
                        commit('SET_OK')
                        resolve(response);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },

        downloadXml:({commit}, uuid) => {
            return new Promise((resolve, reject) => {
                http.get(`/cfdis/${uuid}/xml?download=true`, {responseType: 'blob'})
                    .then((response) => {
                        commit('SET_OK')
                        resolve(response);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        downloadPdf:({commit}, uuid) => {
            return new Promise((resolve, reject) => {
                http.get(`/cfdis/${uuid}/pdf?download=true`, {responseType: 'blob'})
                    .then((response) => {
                        commit('SET_OK')
                        resolve(response);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },

    }

}
